import React, { Component } from 'react';
import {Link} from "react-router-dom";
import $ from "jquery";

import "./../styles/fonts.css";
import "./../styles/icons.css";
import "./../styles/principalStyle.css";

import tranquiAPK from "./../PDF/Tranqui.apk";

import VentanaColores from "./VentanaColores";

export default class PagPrincipal extends Component {
    state = {
        isOpen: false
    }
    fadeOut = () => {
        this.setState({isOpen: false});
    }
    fadeIn = () => {
        this.setState({isOpen: true});
    }

    componentDidMount(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setTimeout(function(){$("#APKB").addClass("activeBallon");}, 800);

            $("#cancelDownload").click(function(){
                $("#APKB").removeClass("activeBallon");
            });
        }
    }

    render() {
        return (
            <div className="PagPrincipal">
                <div
                    className="btnTrigger"
                    onClick={() => {this.fadeIn()}}
                >
                    <i className="material-icons-round prefix">palette</i>Cambiar color
                </div>
                <VentanaColores isOpen={this.state.isOpen} closeWindow={this.fadeOut}/>
                <div className="interface">
                    <div className="logo">Tranqui</div>
                    <div className="mainBtns">
                        <Link className="btn mainAyuda" style={{gridColumn: "1 / 3"}} to="/window/decision"><i className="material-icons-round prefix">priority_high</i>Necesito Ayuda</Link>
                        <Link className="btn midLink" to="/extra/conozcoAlguien"><i className="material-icons-round prefix">people</i>Conozco a Alguien</Link>
                        <Link className="btn midLink" to="/extra/profesionales"><i className="material-icons-round prefix">person</i>Profesionales</Link>
                        <Link className="btn" style={{gridColumn: "1 / 3"}} to="/extra/masInfo"><i className="material-icons-round prefix">add</i>Información</Link>
                    </div>
                    <div className="secBtns">
                        <Link className="btn lgLink btnLogin" to="/login"><i className="material-icons-round prefix">how_to_reg</i>Iniciar Sesión</Link>
                        <Link className="btn lgLink btnSignUp" to="/register"><i className="material-icons-round prefix">person_add</i>Registrarse</Link>
                    </div>
                </div>
                <div className="ballonAPK" id="APKB">
                    <p>¿Estás en celular? Descargá la aplicación ahora!</p>
                    <a className="btn" href={tranquiAPK} download="Tranqui"><i className="material-icons-round prefix">cloud_download</i>Descargar</a>
                    <button className="btn" id="cancelDownload"><i className="material-icons-round prefix">clear</i>Más tarde</button>
                </div>
            </div>
        )
    }
}
